var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup9080(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 151,
    viewBox: "0 0 207 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 9080",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 68",
    filter: "url(#filter0_f_2155_9407)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.667,
    cy: 75.5099,
    rx: 43.1998,
    ry: 14.4747,
    fill: "url(#paint0_angular_2155_9407)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 69",
    filter: "url(#filter1_f_2155_9407)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.667,
    cy: 75.5099,
    rx: 43.1998,
    ry: 14.4747,
    fill: "url(#paint1_angular_2155_9407)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2155_9407",
    x: 0.323708,
    y: 0.892067,
    width: 206.687,
    height: 149.235,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.0715,
    result: "effect1_foregroundBlur_2155_9407"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2155_9407",
    x: 0.323708,
    y: 0.892067,
    width: 206.687,
    height: 149.235,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.0715,
    result: "effect1_foregroundBlur_2155_9407"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_2155_9407",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.667 75.5099) rotate(109.997) scale(51.6695 201.804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0041FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_2155_9407",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.667 75.5099) rotate(83.7418) scale(27.9774 86.1171)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05D6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4675FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9080);
export default __webpack_public_path__ + "static/media/Group 9080.d40d9ebe5f4f96e0bc95a37514db8796.svg";
export { ForwardRef as ReactComponent };